import { RoleUndefined } from './RoleUndefined';

export default RoleUndefined;
